/**
 * Executes a function a max of once every n milliseconds
 */
export function throttle(
	callback: (args: IArguments) => void,
	delay: number,
	options = { leading: true, trailing: false }
) {
	let wait = false

	return function () {
		if (!wait) {
			if (options.leading) {
				// eslint-disable-next-line prefer-spread, prefer-rest-params
				callback.apply(null, arguments)
			}

			wait = true

			setTimeout(function () {
				wait = false

				if (options.trailing) {
					// eslint-disable-next-line prefer-spread, prefer-rest-params
					callback.apply(null, arguments)
				}
			}, delay)
		}
	}
}
